document.addEventListener('DOMContentLoaded', function () {

    function initializeVideoScript() {
      const productBlocks = document.querySelectorAll('.product-block');
      productBlocks.forEach(block => {
        const hoverTarget = block.querySelector('.image-cont--with-secondary-image');
        const video = block.querySelector('.pdp-video');
  
        if (!hoverTarget || !video) return;
  
        /*
        video.pause();
        // Zorg ervoor dat de 'src' pas wordt ingesteld wanneer de video wordt afgespeeld
        video.addEventListener('play', () => {
          if (!video.src) {
            video.src = video.getAttribute('data-src');
            console.log('video src observed');
          }
        });
  */

        video.pause();

        // Zet src zodra de video in de viewport komt
        const observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              if (!video.src) {
                video.src = video.getAttribute('data-src');
                console.log('video src set via viewport');
              }
              observer.unobserve(video);
            }
          });
        }, {
          root: null,        // viewport
          threshold: 0.75    // 75% visible
        });
        observer.observe(video);

        hoverTarget.addEventListener('mouseenter', () => {
          pauseAllExcept(video);
          video.play();
        });
  
        hoverTarget.addEventListener('mouseleave', () => {
          video.pause();
          video.currentTime = 0; 
        });
      });
  
      const mobileTargets = document.querySelectorAll('.product-block__image--secondary');
  
      mobileTargets.forEach(target => {
        const observer = new MutationObserver(mutations => {
          mutations.forEach(mutation => {
            if (
              mutation.type === "attributes" &&
              mutation.attributeName === "class"
            ) {
              const isActive = target.classList.contains('product-block__image--active');
              const video = target.querySelector(':scope > video');
  
              if (video) {
                if (isActive) {
                //  pauseAllExcept(video);
                  video.play();
                } else {
                  video.pause();
                }
              }
            }
          });
        });
        observer.observe(target, { attributes: true });
      });
    }
  
    function pauseAllExcept(activeVideo) {
      const allVideos = document.querySelectorAll('.pdp-video, .product-block__image--secondary video');
      allVideos.forEach(v => {
        if (v !== activeVideo) {
          v.pause();
        }
      });
    }
    initializeVideoScript();
  
    function initializePaginationLinks() {
      const paginationLinks = document.querySelectorAll('.pagination__link');
      paginationLinks.forEach(link => {
        link.removeEventListener('click', handlePaginationClick); 
        link.addEventListener('click', handlePaginationClick);
      });
    }
  
    function handlePaginationClick(event) {
      event.preventDefault(); 
      setTimeout(function() {
        initializeVideoScript(); 
        initializePaginationLinks(); 
        console.log('Videos en paginering opnieuw geïnitialiseerd');
      }, 3000); 
    }
    initializePaginationLinks();
  
  });